import { ActionWithPayload as Action, Reducer } from "common/types/redux";

import {
  receiveAssignment,
  TeacherAssignmentsState
} from "seneca-common/features/assignments/features/teacher-assignments/state";
import { getAssignees } from "seneca-common/features/assignments/features/teacher-assignments/state/selectors/state/assignments/assignment/teacherAssignment";

import actionTypes from "../action-types";

export default function teacherAssignmentsReducerWrapper(
  teacherAssignmentsReducer: Reducer<TeacherAssignmentsState>
) {
  return function (
    teacherAssignmentsState: TeacherAssignmentsState,
    action: Action<any>
  ) {
    switch (action.type) {
      case actionTypes.RECEIVE_CLASS:
        return receiveClass(
          teacherAssignmentsReducer,
          teacherAssignmentsState,
          action
        );

      default:
        return teacherAssignmentsReducer(teacherAssignmentsState, action);
    }
  };
}

function receiveClass(
  teacherAssignmentsReducer: Reducer<TeacherAssignmentsState>,
  teacherAssignmentsState: TeacherAssignmentsState,
  action: Action<any>
): TeacherAssignmentsState {
  const { classId, enrollments = [] } = action.payload;

  return teacherAssignmentsState.withMutations(teacherAssignmentsState => {
    const assignmentsInClass = teacherAssignmentsState.assignments.filter(
      assignment => assignment.classId === classId
    );

    assignmentsInClass.forEach(assignment => {
      const classUserIds = enrollments.map((e: any) => e.userId);
      const assignees = getAssignees(assignment);
      const newAssignees = assignees.reduce((acc, assignee, userId) => {
        if (classUserIds.includes(userId)) {
          //@ts-ignore
          acc.push({ ...assignee.toJS(), id: assignment.id, userId });
        }
        return acc;
      }, []);

      const questionAggregations = assignment.questionAggregations
        ? {
            ...assignment.questionAggregations?.toJS(),
            questions: [
              ...assignment.questionAggregations?.questions!.toArray()
            ]
          }
        : undefined;

      teacherAssignmentsReducer(
        teacherAssignmentsState,
        receiveAssignment({
          ...assignment.toJS(),
          assignees: newAssignees,
          questionAggregations
        } as any)
      );
    });
  });
}
